// frontend/src/components/KakaoMap.js
import React, { useEffect, useRef, useState } from "react";
import "../styles/OverlayPanel.css";
import iconResidence from "../assets/markers/marker_residence.png";
import iconCommerce  from "../assets/markers/marker_commerce.png";
import iconBusiness  from "../assets/markers/marker_business.png";
import iconProfit    from "../assets/markers/marker_profit.png";
import iconGray      from "../assets/markers/markerGray.png";
// =========== 제미나이 제안 (추가) 2026.01.18
import { getAddressKey } from "../utils/addressGroup"; // 1. import 추가
// =========== 제미나이 제안 (추가) 2026.01.18

// =========== 제미나이 제안 (삭제) 2026.01.18

// function normalizeBuildingAddress(p) {
//   // 1) 지번 주소 우선
//   const raw = p.jibunAddress || p.roadAddress;
//   if (!raw) return null;

//   // 2) 호 / 층 / 동 정보 제거 (건물 단위까지만)
//   return raw
//     .replace(/\s*\d+동\s*\d+호.*$/, "")
//     .replace(/\s*\d+호.*$/, "")
//     .replace(/\s*\d+층.*$/, "")
//     .trim();
// }

// =========== 제미나이 제안 (삭제) 2026.01.18

const KAKAO_APP_KEY = "3b72256b73696ef033a88934ccd70232"; // 회원님의 카카오맵 앱 키
const KAKAO_SDK_URL = `//dapi.kakao.com/v2/maps/sdk.js?appkey=${KAKAO_APP_KEY}&libraries=services,clusterer&autoload=false`;

// ★ 각 아이콘의 url, 너비(width), 높이(height)를 함께 관리하는 객체로 변경
const MARKER_INFO = {
  residence: { url: iconResidence, width: 36, height: 36 }, // 가시성을 위해 소폭 확대
  commerce:  { url: iconCommerce,  width: 36, height: 36 },
  business:  { url: iconBusiness,  width: 42, height: 42 },
  profit:    { url: iconProfit,    width: 36, height: 36 },
  gray:      { url: iconGray,      width: 36, height: 36 },
};
const HIGHLIGHT_IMAGE_URL = "https://t1.daumcdn.net/localimg/localimages/07/mapapidoc/markerStar.png";

const KakaoMap = ({ properties = [], center, highlightedId, onMarkerClick = () => {}, onExpandMap = () => {}, mapExpanded = false, onOpenPopup = null }) => {
  // onExpandMap: 지도 확대 버튼 클릭 시 App.js의 setMapExpanded(true)를 실행시키기 위한 함수.
  // App.js에서 <KakaoMap onExpandMap={() => setMapExpanded(true)} /> 형태로 전달받음.
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const clustererRef = useRef(null);
  const rvContainerRef = useRef(null); // 로드뷰용 컨테이너
  const rvInstanceRef = useRef(null); // 로드뷰 인스턴스 저장용 ref
  const mapWalkerRef = useRef(null); // MapWalker 객체 보관용 ref
  const markerMapRef = useRef(new Map());
  const iconsRef = useRef({});
  const infoWindowRef = useRef(null);
  const popupOverlayRef = useRef(null);

  // 기능 활성화 상태 관리
  const [showDistrict, setShowDistrict] = useState(false); // 지적편집도
  const [isRoadviewMode, setIsRoadviewMode] = useState(false); // 로드뷰 모드

  // ★ 1. 지도가 완전히 준비되었는지 확인하는 상태 변수 추가
  const [isMapReady, setMapReady] = useState(false);

  // mapExpanded(지도 확대/축소 상태)가 바뀔 때마다 호출됨.
  // CSS로 지도 컨테이너의 height가 바뀌면, 카카오맵은 그 변화를 자동으로 알아채지 못해서
  // 지도 일부가 비거나(빈 회색 영역) 드래그 시 새 타일이 안 불러와지는 문제가 생김.
  // relayout()을 호출하면 카카오맵이 "컨테이너 크기가 바뀌었다"는 걸 인식하고 다시 그림.
  useEffect(() => {
    if (!mapRef.current) return;
    // CSS height 트랜지션(0.25초)이 끝난 뒤에 relayout을 호출해야 정확한 크기를 잡으므로
    // 약간의 지연(트랜지션 시간과 맞춤)을 줌
    const timer = setTimeout(() => {
      mapRef.current.relayout();
      // relayout 직후, 중심 좌표가 살짝 틀어지는 경우가 있어 center로 재설정해줌
      if (center) {
        const newCenter = new window.kakao.maps.LatLng(center.lat, center.lng);
        mapRef.current.setCenter(newCenter);
      }
    }, 300);
    return () => clearTimeout(timer);
  }, [mapExpanded]);

  // 지도 SDK 로딩 및 초기화 (최초 1회만 실행)
  useEffect(() => {
    // 스크립트가 이미 '완전히' 로드됐을 때만 바로 초기화합니다.
    //   팝업 창처럼 SDK 가 아직 로딩 중이면 maps 네임스페이스는 있어도
    //   LatLng 이 없어서 'not a constructor' 오류가 납니다. → LatLng 유무로 판별.
    if (window.kakao && window.kakao.maps && window.kakao.maps.LatLng) {
      if (!mapRef.current) initMap();
      return;
    }
    // 스크립트는 있으나 아직 로드 전 → load 콜백으로 초기화
    if (window.kakao && window.kakao.maps && window.kakao.maps.load) {
      window.kakao.maps.load(() => { if (!mapRef.current) initMap(); });
      return;
    }

    const script = document.createElement("script");
    script.src = KAKAO_SDK_URL;
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.kakao.maps.load(initMap);
    };

    function initMap() {
      if (!containerRef.current) return;
      const kakao = window.kakao;
      const map = new kakao.maps.Map(containerRef.current, {
        center: new kakao.maps.LatLng(center.lat, center.lng),
        level: center.level,
      });
      mapRef.current = map;

      infoWindowRef.current = new kakao.maps.InfoWindow({ removable: true, zIndex: 10 });
      popupOverlayRef.current = new kakao.maps.CustomOverlay({ 
        yAnchor: 1.12,
        zIndex: 10000
      }); // 말풍선 아래쪽 기준

      kakao.maps.event.addListener(map, "click", () => infoWindowRef.current?.close());

      // 아이콘 이미지 객체 생성
      const starMarkerSize = new kakao.maps.Size(24, 35);
      iconsRef.current.highlight = new kakao.maps.MarkerImage(HIGHLIGHT_IMAGE_URL, starMarkerSize);

      // for-in 루프를 사용해 각 마커 정보를 순회
      for (const key in MARKER_INFO) {
        const info = MARKER_INFO[key];
        const size = new kakao.maps.Size(info.width, info.height); // ★ 각자의 크기로 Size 객체 생성
        // 마커의 발끝이 좌표 지점에 오도록 설정 (가로 절반, 세로 전체)
          const option = {
            offset: new kakao.maps.Point(info.width / 2, info.height) 
          };
        iconsRef.current[key] = new kakao.maps.MarkerImage(info.url, size);
      }
      
      clustererRef.current = new kakao.maps.MarkerClusterer({
        map: map,
        averageCenter: true,
        minLevel: 6,
      });

      setMapReady(true);
    }
  }, []); // 초기 로딩 시 1회만 실행

  // 로드뷰 인스턴스 초기화 및 클릭 이벤트 분리 (클로저 문제 해결)
  useEffect(() => {
    if (!isMapReady || !mapRef.current) return;
    const kakao = window.kakao;
    const map = mapRef.current;

    // 로드뷰 인스턴스 생성 (없을 경우에만)
    if (!rvInstanceRef.current && rvContainerRef.current) {
      rvInstanceRef.current = new kakao.maps.Roadview(rvContainerRef.current);
    }

    const rv = rvInstanceRef.current;
    const rvClient = new kakao.maps.RoadviewClient();

    // [추가] 제공된 MapWalker 클래스 로직 이식
    const initMapWalker = (pos) => {
      if (mapWalkerRef.current) return;

      const content = document.createElement('div');
      const figure = document.createElement('div');
      const angleBack = document.createElement('div');

      content.className = 'MapWalker';
      figure.className = 'figure';
      angleBack.className = 'angleBack';

      content.appendChild(angleBack);
      content.appendChild(figure);

      const walker = new kakao.maps.CustomOverlay({
        position: pos,
        content: content,
        yAnchor: 1
      });

      mapWalkerRef.current = {
        walker,
        content,
        setAngle: function(angle) {
          const threshold = 22.5;
          for (let i = 0; i < 16; i++) {
            if (angle > (threshold * i) && angle < (threshold * (i + 1))) {
              const className = 'm' + i;
              this.content.className = 'MapWalker ' + className;
              break;
            }
          }
        },
        setPosition: function(p) { this.walker.setPosition(p); },
        setMap: function(m) { this.walker.setMap(m); }
      };
      mapWalkerRef.current.setMap(mapRef.current);
    };

    kakao.maps.event.addListener(rv, 'init', () => {
      initMapWalker(rv.getPosition());
    });

    // 로드뷰 조작 이벤트 연동
    kakao.maps.event.addListener(rv, 'viewpoint_changed', () => {
      const vp = rv.getViewpoint();
      if (mapWalkerRef.current) mapWalkerRef.current.setAngle(vp.pan);
    });

    kakao.maps.event.addListener(rv, 'position_changed', () => {
      const pos = rv.getPosition();
      if (mapWalkerRef.current) {
        mapWalkerRef.current.setPosition(pos);
        mapRef.current.setCenter(pos);
      }
    });

    const handleMapClick = (mouseEvent) => {
      if (!isRoadviewMode) return;

      const position = mouseEvent.latLng;
      rvClient.getNearestPanoId(position, 50, (panoId) => {
        if (panoId) {
          const wrapper = document.getElementById("rvWrapper");
          wrapper.style.display = "block";

          if (mapWalkerRef.current) {
            mapWalkerRef.current.setMap(mapRef.current);
            mapWalkerRef.current.setPosition(position);
          }
          
          // 중요: display block 직후에 relayout을 호출해야 화면이 깨지지 않음
          setTimeout(() => {
            rv.relayout();
            rv.setPanoId(panoId, position);
          }, 100);
        } else {
          alert("로드뷰를 사용할 수 없는 지점입니다.");
        }
      });
    };

    kakao.maps.event.addListener(map, "click", handleMapClick);
    return () => {
      kakao.maps.event.removeListener(map, "click", handleMapClick);
      if (!isRoadviewMode && mapWalkerRef.current) {
        mapWalkerRef.current.setMap(null);
      }
    };
  }, [isMapReady, isRoadviewMode]); // 로드뷰 모드 변경 시 리스너 갱신

  // 지적편집도 레이어 토글
  useEffect(() => {
    if (!isMapReady || !mapRef.current) return;
    const kakao = window.kakao;
    if (showDistrict) {
      mapRef.current.addOverlayMapTypeId(kakao.maps.MapTypeId.USE_DISTRICT);
    } else {
      mapRef.current.removeOverlayMapTypeId(kakao.maps.MapTypeId.USE_DISTRICT);
    }
  }, [showDistrict, isMapReady]);

  // 로드뷰 도로 레이어 토글
  useEffect(() => {
    if (!isMapReady || !mapRef.current) return;
    const kakao = window.kakao;
    if (isRoadviewMode) {
      mapRef.current.addOverlayMapTypeId(kakao.maps.MapTypeId.ROADVIEW);
    } else {
      mapRef.current.removeOverlayMapTypeId(kakao.maps.MapTypeId.ROADVIEW);
    }
  }, [isRoadviewMode, isMapReady]);

    // 반응형 컨테이너 크기 유지
  useEffect(() => {
    if (!containerRef.current) return;
    containerRef.current.style.width = "100%";
    containerRef.current.style.height = "100%";
  }, []);

  // 지도 중심/레벨 변경 처리
  useEffect(() => {
    if (!isMapReady || !mapRef.current || !center) return;
    const { lat, lng, level } = center;
    const newCenter = new window.kakao.maps.LatLng(lat, lng);
    mapRef.current.setCenter(newCenter);
    if (level && mapRef.current.getLevel() !== level) {
      mapRef.current.setLevel(level);
    }
  }, [center, isMapReady]);

  // 마커 업데이트 처리
  useEffect(() => {
    if (!isMapReady || !mapRef.current || !clustererRef.current) return;

    const clusterer = clustererRef.current;
    clusterer.clear();
    markerMapRef.current.clear();

    // 1️⃣ 동일 건물(PNU) 기준 그룹핑 (호리스트 핵심)
    const groups = {};
    for (const p of properties) {

// =========== 제미나이 제안 (수정) 2026.01.18
      const key = getAddressKey(p); // 공통 함수 사용
// =========== 제미나이 제안 (수정) 2026.01.18

      if (!key) continue;
      if (!groups[key]) groups[key] = [];
      groups[key].push(p);
    }

    const newMarkers = Object.entries(groups)
      .map(([address, items]) => {
        // 대표 좌표: lat/lng 정상인 첫 매물
        const base = items.find(
          it => Number(it.lat) !== 0 && Number(it.lng) !== 0
        );
        if (!base) return null;
        const id = base.estate_no;
        const iconKey =
          (base.contract_yn === "n")
            ? "gray"
            : (base.estate_type || "business");
        const icon = iconsRef.current[iconKey] || iconsRef.current.business;

        const position = new window.kakao.maps.LatLng(
          Number(base.lat),
          Number(base.lng)
        );

        const marker = new window.kakao.maps.Marker({
          position,
          image: icon,
          title: base.estate_name || base.title || ""
        });

        marker.normalIcon = icon;
        marker.propertyId = id;


        window.kakao.maps.event.addListener(marker, "click", () => {
          mapRef.current.panTo(marker.getPosition());
 console.log(
   "[MARKER CLICK]",
// =========== 제미나이 제안 (수정) 2026.01.18
   "buildingKey =", getAddressKey(base),
// =========== 제미나이 제안 (수정) 2026.01.18
   "count =", items.length
 );
        const esc = (s) =>
          String(s ?? "").replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));

        const name = base.estate_name || base.title || "";
        const html = `
          <div style="
            max-width:260px; box-sizing:border-box;
            background:#fff; border:1px solid #d0d3d8; border-radius:8px;
            box-shadow:0 6px 20px rgba(0,0,0,0.18);
            padding:8px 10px;
            font-size:12px; line-height:1.5; color:#16181d;
            word-break:keep-all; overflow-wrap:break-word; white-space:normal;
            transform:translateZ(0);  /* 렌더 테어링 방지 */
          ">
            <div style="font-weight:600; margin-bottom:4px;">
              ${esc(name)}${name ? " •" : ""}
            </div>
             <div>${esc(base.price ?? "")}</div>
          </div>
          <div style="
            width:0;height:0; margin:0 auto; /* 중앙 화살표 */
            border-left:8px solid transparent; border-right:8px solid transparent;
            border-top:8px solid #fff; filter: drop-shadow(0 -1px 0 #d0d3d8);
          "></div>
        `;

        popupOverlayRef.current.setContent(html);
        popupOverlayRef.current.setPosition(marker.getPosition());
        popupOverlayRef.current.setZIndex(10000);
        popupOverlayRef.current.setMap(mapRef.current);

        // 필요 시: 기존 InfoWindow는 닫기
        infoWindowRef.current.close?.();

        // 마커외 지도 클릭 시 인포윈도우 닫기
         window.kakao.maps.event.addListener(mapRef.current, "click", () => {
          popupOverlayRef.current?.setMap(null);
        });

          if (items.length === 1) {
            onMarkerClick(items[0].estate_no, items[0]);
          } else {
// =========== 제미나이 제안 (수정) 2026.01.18

            // 여러 개일 때: 첫 번째 인자를 null이 아닌 대표 ID로 주거나, 
            // App.js에서 'group' 타입을 처리할 수 있게 합니다.
            onMarkerClick(base.estate_no, {
              type: "group",
              items: items
              
// =========== 제미나이 제안 (수정) 2026.01.18
            });
          }

        infoWindowRef.current.setZIndex(9999);        // 다른 요소에 가려질 때
        // infoWindowRef.current.setOptions({ disableAutoPan: false }); // 자동팬 유지
        });
        
        // 그룹 내 모든 매물 → 같은 마커 참조
        items.forEach(it => {
          markerMapRef.current.set(it.estate_no, marker);
        });
        return marker;
      })
      .filter(Boolean);

    if (newMarkers.length > 0) {
      clusterer.addMarkers(newMarkers);
    }
  }, [properties, isMapReady]); // ★ 지도가 준비된 후 properties가 변경될 때마다 실행

  // 마커 강조 효과 및 우선순위(Z-Index) 처리
  useEffect(() => {
    if (!isMapReady) return;
    const markerMap = markerMapRef.current;
    if (!markerMap.size) return;

    // 1. 모든 마커 초기화 (이미지 복구 및 Z-Index 기본값 설정)
    markerMap.forEach(marker => {
      if (marker.getImage() !== marker.normalIcon) {
        marker.setImage(marker.normalIcon);
      }
      marker.setZIndex(1); // 기본 우선순위
    });

    // 2. 선택된 매물이 있다면 해당 마커를 최상단으로 올림
    if (highlightedId && markerMap.has(highlightedId)) {
      const markerToHighlight = markerMap.get(highlightedId);
      
      // 강조 이미지 적용
      markerToHighlight.setImage(iconsRef.current.highlight);
      
      // ★ 핵심: Z-Index를 높게 설정하여 겹쳐진 다른 마커보다 위에 출력
      markerToHighlight.setZIndex(100); 

      // (선택사항) 지도 중심을 해당 마커로 부드럽게 이동하고 싶을 경우
      // mapRef.current?.panTo(markerToHighlight.getPosition());
    }
  }, [highlightedId, isMapReady]);

  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      <div ref={containerRef} style={{ width: "100%", height: "100%" }} />
      
      {/* 컨트롤 버튼 모음: 단위변환 박스와 같은 높이(top), 화면 우측에 가로로 배열 */}
      <div style={{ 
        position: "absolute", 
        top: "75px",   
        // App.js의 좌측 컨트롤(패널열기→단위변환)이 세로로 쌓이는 높이를 감안해
        // 모바일 기준 단위변환 박스가 보통 위치하는 높이에 맞춤.
        // 화면 보고 살짝 안 맞으면 이 값만 90~110px 사이로 조정하면 됨.
        right: "100px",   // 좌측 컨트롤과 겹치지 않게 화면 우측에 배치
        zIndex: 10, 
        display: "flex", 
        flexDirection: "row",
        gap: "6px" 
      }}>
        <button 
          onClick={() => setShowDistrict(!showDistrict)}
          className={`map-ctrl-btn ${showDistrict ? 'active' : ''}`}
          title="지적편집도"
        >
          🗺️ 지적
        </button>
        <button 
          onClick={() => setIsRoadviewMode(!isRoadviewMode)}
          className={`map-ctrl-btn ${isRoadviewMode ? 'active' : ''}`}
          title="로드뷰"
        >
          📷 로드뷰
        </button>
        <button 
          onClick={() => onExpandMap()}
          className="map-ctrl-btn"
          title={mapExpanded ? "지도 축소" : "지도 확대"}
        >
          🔍 {mapExpanded ? "축소" : "확대"}
        </button>
        {onOpenPopup && (
          <button
            onClick={() => onOpenPopup()}
            className="map-ctrl-btn"
            title="팝업 지도(다른 창으로 열기)"
          >
            🔗 팝업지도
          </button>
        )}
      </div>

      {/* 로드뷰 출력 영역 (전체 지도의 오른쪽 1/3) */}
      <div id="rvWrapper" style={{ 
        display: "none", 
        position: "absolute", 
        top: 0, 
        right: 0, 
        width: "33.3%", 
        height: "100%", 
        zIndex: 20000, 
        borderLeft: "2px solid #2563eb", 
        background: "#000"
      }}>
        <div ref={rvContainerRef} style={{ width: "100%", height: "100%" }} />
        <button 
          onClick={() => {
            // 1. 로드뷰 창 닫기
            document.getElementById("rvWrapper").style.display = "none";
            // 2. 지도에서 동동이(MapWalker) 제거
            if (mapWalkerRef.current) {
              mapWalkerRef.current.setMap(null);
            }
          }}
          style={{ position: "absolute", top: "10px", left: "10px", zIndex: 101, padding: "5px 10px", background: "#fff", border: "1px solid #ccc", cursor: "pointer", borderRadius: "4px" }}
        >
          닫기
        </button>
      </div>
    </div>
  );
};

export default KakaoMap;